import React, { ReactElement, ReactNode } from 'react'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  cn,
} from '@rewardops/ui'

interface SidebarProps {
  title: string
  children: ReactElement
  openByDefault?: boolean
  shouldBeHidden?: boolean
  showTopSeparator?: boolean
}

export const FilterBase: React.FC<SidebarProps> = ({
  title,
  children,
  openByDefault = false,
  shouldBeHidden = false,
  showTopSeparator = false,
}) => {
  if (shouldBeHidden) {
    return null
  }

  return (
    <Accordion
      type="single"
      collapsible
      defaultValue={openByDefault ? title : undefined}
    >
      <AccordionItem value={title}>
        <AccordionTrigger
          className={cn(
            { 'mt-4 border-t': showTopSeparator },
            'font-semibold hover:text-tenant-primary-color hover:no-underline',
          )}
        >
          {title}
        </AccordionTrigger>
        <AccordionContent>
          <>{children}</>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}

export default FilterBase
